<div class="stat-container" *ngFor="let item of gridHeaderStatistics; let i = index, trackBy: trackByIndex">
  <div class="stat-container__content" [ngClass]="getClass(item)">
    <div class="stat-container__header">{{item.key}}</div>
    <a class="stat-container__count" (click)="applyStatisticsFilter(item.key)" title="{{item.value}}">{{item.value}}</a>
  </div>
</div>
